import { getDefaultFilter } from '@refinedev/antd'
import type { CrudFilters } from '@refinedev/core'
import { Form, type FormProps, Input, Select, Space } from 'antd'

import { UserSearchSelect } from '@/components/common/UserSearchSelect'
import { PUBLIC_IP_STATUSES } from '@/constants/statuses'
import { useClusters } from '@/hooks/useClusters'

interface NetworkFilterFormProps {
  searchFormProps: FormProps
  filters: CrudFilters
}

export function NetworkFilterForm({
  searchFormProps,
  filters,
}: NetworkFilterFormProps) {
  const clusters = useClusters()

  return (
    <Form
      {...searchFormProps}
      layout="inline"
      style={{ marginBottom: 16 }}
      initialValues={{
        search:
          getDefaultFilter('name', filters, 'eq') ??
          getDefaultFilter('ids', filters, 'eq'),
        address: getDefaultFilter('address', filters, 'eq'),
        status: getDefaultFilter('status', filters, 'eq'),
        clusterId: getDefaultFilter('clusterId', filters, 'eq'),
      }}
    >
      <Space wrap>
        <Form.Item name="search" noStyle>
          <Input.Search
            placeholder="Search by name or ID..."
            style={{ width: 250 }}
            onSearch={() => searchFormProps.form?.submit()}
            allowClear
          />
        </Form.Item>
        <Form.Item name="address" noStyle>
          <Input.Search
            placeholder="Search by IP address..."
            style={{ width: 200 }}
            onSearch={() => searchFormProps.form?.submit()}
            allowClear
          />
        </Form.Item>
        <Form.Item name="status" noStyle>
          <Select
            placeholder="Status"
            style={{ width: 140 }}
            allowClear
            onChange={() => searchFormProps.form?.submit()}
            options={PUBLIC_IP_STATUSES.map((s) => ({ label: s, value: s }))}
          />
        </Form.Item>
        <Form.Item name="userId" noStyle>
          <UserSearchSelect onChange={() => searchFormProps.form?.submit()} />
        </Form.Item>
        <Form.Item name="clusterId" noStyle>
          <Select
            placeholder="Cluster"
            style={{ width: 200 }}
            allowClear
            showSearch
            optionFilterProp="label"
            onChange={() => searchFormProps.form?.submit()}
            options={clusters.map((c) => ({
              label: c.name ?? c.id,
              value: c.id,
            }))}
          />
        </Form.Item>
      </Space>
    </Form>
  )
}
